import type { FilterComponentProps } from '@/app/common/filters/core/filterComponentType.ts';
import type { FilterDataSearch } from '@/app/common/filters/core/filtersTypes.ts';
import { FilterBadgeContent } from '@/app/common/filters/surfaces/badges/FilterBadgeContent.tsx';
import React from 'react';
import styled from 'styled-components';

const SearchBadgeOptions = styled.div``;

export const FilterSearchBadge = ({ filter, isLoading, handleFilterChanged }: FilterComponentProps) => {
  const filterData = filter.data as FilterDataSearch;

  const handleFilterClicked = (valueClicked: string) => {
    const updatedOptions = filterData.options.map((option) =>
      option.value === valueClicked ? { ...option, selected: false } : option
    );
    const updatedFilter = {
      ...filter,
      data: {
        ...filter.data,
        options: updatedOptions,
      },
    };
    handleFilterChanged([updatedFilter]);
  };

  const options = filterData.options
    .filter((option) => option.selected)
    .map((option) => (
      <FilterBadgeContent
        key={option.label}
        label={option.label}
        handleFilterClicked={() => handleFilterClicked(option.value)}
        isLoading={isLoading}
      />
    ));

  return <SearchBadgeOptions>{options}</SearchBadgeOptions>;
};
